const KeenSlider = window.KeenSlider

const { debounce } = window.BAO.Utils
const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins

class CtaLifestyle extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = null
    this.handleResize = debounce(this.setupCarousel.bind(this), 200)

    window.addEventListener('resize', this.handleResize)

    this.setupCarousel()
  }

  disconnectedCallback () {
    super.disconnectedCallback()
    window.removeEventListener('resize', this.handleResize)
    this.destroyCarousel()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    if (window.BAO.MediaBreakpoints.isLg) {
      this.destroyCarousel()
      return
    }

    if (this.carousel) return

    this.carousel = new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.05,
          spacing: 10,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 1.75,
              spacing: 10,
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView: 2.05,
              spacing: 10,
            },
          },
        },
      },
      [setInitialised(), addWheelControls('horizontal')],
    )
  }

  destroyCarousel () {
    if (this.carousel?.destroy) {
      this.carousel.destroy()
      this.carousel = null
    }
  }
}

if (!customElements.get('cta-lifestyle')) {
  customElements.define('cta-lifestyle', CtaLifestyle)
}
